import { createApp, ref, ComponentPublicInstance } from 'vue'
import Loading from '../components/Loading.vue'

const show = ref(false)
const message = ref('')

let loadingEle: ComponentPublicInstance

const loading = {
  show(msg?: string) {
    if (!loadingEle) {
      loadingEle = createApp(Loading, { show, message }).mount(
        document.createElement('div')
      )
      document.body.appendChild(loadingEle.$el)
    }
    show.value = true
    message.value = msg || 'loading...'
  },
  hide() {
    // 控制loading隐藏的方法
    show.value = false
  }
}
export { loading }
